import React from "react";
import { motion } from "framer-motion";
import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";

import PhasePlaceholder from "../../../Utils/Assets/Images/PhasePlaceholder1.png";
import iconStakeMVR from "../../../Utils/Assets/Images/iconStakeMVR.png";
import iconStakeMVR1 from "../../../Utils/Assets/Images/iconStakeMVR1.png";
import iconStakeMVR2 from "../../../Utils/Assets/Images/iconStakeMVR2.png";
import iconStakeMVR3 from "../../../Utils/Assets/Images/iconStakeMVR3.png";

const StakeMVR = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, x: 20 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };

    const floatingAnimation = {
        y: [0, -15, 0],
        transition: {
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut",
        },
    };

    return (
        <div className={styles.stakeWrapper}>
            <MeetUsWrapper>
                <div className={styles.stakeContent}>
                    <div
                        className={styles.stakeCard}
                        data-aos="fade-up"
                        data-aos-duration="1000"
                    >
                        <div className={styles.stakeFlex}>
                            <div className={styles.stakeImageContainer}>
                                <motion.div
                                    className={styles.stakePhoneFrame}
                                    animate={floatingAnimation}
                                    initial={{ opacity: 0, scale: 0.9 }}
                                    whileInView={{ opacity: 1, scale: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.8 }}
                                >
                                    <img
                                        src={PhasePlaceholder}
                                        alt="PhasePlaceholder"
                                        className={styles.stakeImage}
                                    />
                                </motion.div>
                            </div>

                            <motion.div
                                className={styles.stakeText}
                                variants={containerVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.3 }}
                            >
                                <motion.h1
                                    className={styles.stakeTitle}
                                    variants={itemVariants}
                                >
                                    Why Stake MVR Influence Coins?
                                </motion.h1>

                                <motion.div
                                    className={styles.stakeIconContainer}
                                    variants={itemVariants}
                                    whileHover={{ x: 10 }}
                                >
                                    <motion.img
                                        src={iconStakeMVR}
                                        alt="Stake MVR"
                                        className={styles.stakeIcon}
                                        whileHover={{
                                            scale: 1.2,
                                            rotate: 5,
                                        }}
                                    />
                                    <div className={styles.stakeFlexCol}>
                                        <p className={styles.title}>
                                            Earn Cashback & Fee Discounts
                                        </p>
                                        <p className={styles.stakedes}>
                                            Reduce costs on purchases &
                                            transactions.
                                        </p>
                                    </div>
                                </motion.div>

                                <motion.div
                                    className={styles.stakeIconContainer}
                                    variants={itemVariants}
                                    whileHover={{ x: 10 }}
                                >
                                    <motion.img
                                        src={iconStakeMVR1}
                                        alt="Stake MVR"
                                        className={styles.stakeIcon}
                                        whileHover={{
                                            scale: 1.2,
                                            rotate: 5,
                                        }}
                                    />
                                    <div className={styles.stakeFlexCol}>
                                        <p className={styles.title}>
                                            Gain More Visibility & Brand Deals
                                        </p>
                                        <p className={styles.stakedes}>
                                            Higher levels unlock sponsorships &
                                            paid collaborations.
                                        </p>
                                    </div>
                                </motion.div>

                                <motion.div
                                    className={styles.stakeIconContainer}
                                    variants={itemVariants}
                                    whileHover={{ x: 10 }}
                                >
                                    <motion.img
                                        src={iconStakeMVR2}
                                        alt="Stake MVR"
                                        className={styles.stakeIcon}
                                        whileHover={{
                                            scale: 1.2,
                                            rotate: 5,
                                        }}
                                    />
                                    <div className={styles.stakeFlexCol}>
                                        <p className={styles.title}>
                                            Monetize Your Influence
                                        </p>
                                        <p className={styles.stakedes}>
                                            Host VR events, promote brands, and
                                            earn more rewards.
                                        </p>
                                    </div>
                                </motion.div>

                                <motion.div
                                    className={styles.stakeIconContainer}
                                    variants={itemVariants}
                                    whileHover={{ x: 10 }}
                                >
                                    <motion.img
                                        src={iconStakeMVR3}
                                        alt="Stake MVR"
                                        className={styles.stakeIcon}
                                        whileHover={{
                                            scale: 1.2,
                                            rotate: 5,
                                        }}
                                    />
                                    <div className={styles.stakeFlexCol}>
                                        <p className={styles.title}>
                                            Scale Your Income with Referrals
                                        </p>
                                        <p className={styles.stakedes}>
                                            Grow your influence and earnings by
                                            referring others.
                                        </p>
                                    </div>
                                </motion.div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default StakeMVR;
